<template>
<div>
  <div class="sub-header-container">
    <div class="sub-header-content" style="justify-content: center;">
      <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
        <div class="page-title">Submit new thread 🧵</div>
      </div>
    </div>
  </div>

  <div class="page-container">
    <div style="display: flex; justify-content: center;">
      <div class="new-thread-post-container">

        <p>Title</p>
        <input class="input-add" style="width: 95%; margin-bottom: 30px" placeholder="Enter title" ref="title" v-model="title" @click="select($refs.title, title)" type="text" @keyup.enter="select($refs.primaryTag, primaryTag)">

        <p>Link to the Twitter thread</p>
        <input class="input-add" style="width: 95%; margin-bottom: 30px" placeholder="Example: https://twitter.com/accountname/status/000000000" ref="link" v-model="link" @input="linkChanged" @click="select($refs.link, link)" type="text" @keyup.enter="select($refs.title, title)">

        <div style ="margin-bottom: 30px;">
          <p>Main tags (max. 3)</p>
          <TagsCollection placeholder-active="Add tag" has-to-popup-login ref="tagsCollection" @added-tags="primaryTagAdded($event)" @show-login="$store.state.showLoginModal = true"/>
          <Tag class="tags-button" :tag="tag" v-for="(tag) in primaryTags" :key="tag" @removed-tag="removedPrimaryTag($event)"/>
        </div>

        <div style ="margin-bottom: 30px;">
          <p>Additional tags (max. 3)</p>
          <Tags ref="tags" @added-tags="secondaryTagAdded($event)"/>
          <Tag class="tags-button" :tag="tag" v-for="(tag) in secondaryTags" :key="tag" @removed-tag="removedSecondaryTag($event)"/>
        </div>

        <button class="primary-button" style="width: 100%; margin-left: 0px;" @click="publish">Publish thread</button>

        <div class="separator-container">
          <div class="separator-text"><span>Thread preview</span></div>
        </div>

        <div class="thread-preview-container" style = "margin-top: 5%;">
          <div v-if="title !== ''" class="red-title">{{title}}</div>
          <div v-if="title === ''" class="red-title">This is a fancy title preview</div>
          <div v-if="isValidLink" v-html="html"></div>
          <div v-if="!isValidLink" v-html="previewHtml"></div>
          <div v-for="(t) in tags" class="tags-button" :key="t">{{t}}</div>
        </div>
      </div>
    </div>
    
    <p v-if="errors.showMissingLinkError">Missing or not valid Link.</p>
    <p v-if="errors.showMissingTitleError">Missing Title.</p>
    <p v-if="errors.showMissingPrimaryTagsError">At least one primary tag required.</p>
    <p v-if="errors.showTwitterError">Twitter servers can't fetch the tweet.</p>
    <p v-if="errors.showSuccess">Ok.</p>
    <p v-if="errors.showServerError">Something went wront, contat us.</p>
  </div>
</div>
</template>

<script>
import Tag from '@/components/Tag'
import Tags from '@/components/Tags'
import TagsCollection from '@/components/TagsCollection'
import firebase from '@/firebase'
import router from '@/router'

export default {
  name: 'PostThread',

  components: {
    Tag,
    Tags,
    TagsCollection,
  },

  mounted() {
    this.askEmbed('1325562385961279488', true)
  },

  computed: {
    tags() {
      const joined = this.primaryTags.concat(this.secondaryTags)
      if(joined.length === 0){
        return  ['tag' ,'tag', 'tag',]
      }
      return joined
    },
  },

  data() {
    return {
      regex: /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/,
      html: '',
      link: '',
      title: '',
      previewHtml: '',
      primaryTags: [],
      secondaryTags: [],
      isValidLink: false,
      linkMatch: null,
      errors: {
        showMissingLinkError: false,
        showMissingTitleError: false,
        showMissingPrimaryTagsError: false,
        showTwitterError: false,
        showServerError: false,
        showSuccess: false,
      },
    }
  },

  methods: {
    primaryTagAdded(tag) {
      this.primaryTags.push(tag)
      this.$refs.tagsCollection.showTags = false
    },

    removedPrimaryTag(tag) {
      this.$refs.tagsCollection.removeTag(tag)
      const i = this.primaryTags.indexOf(tag) 
      const exist = i > -1
      if (exist) {
        this.primaryTags.splice(i, 1);
      }
    },

    secondaryTagAdded(tag) {
      this.secondaryTags.push(tag)
    },

    removedSecondaryTag(tag) {
      this.$refs.tags.removeTag(tag)
      const i = this.secondaryTags.indexOf(tag) 
      const exist = i > -1
      if (exist) {
        this.secondaryTags.splice(i, 1);
      }
    },

    linkChanged() {
      this.resetMessages()
      this.linkMatch = this.link.match(this.regex)
      this.isValidLink = this.linkMatch != null
      if(!this.isValidLink){
        return
      }

      this.askEmbed(this.linkMatch[3], false)
    },

    askEmbed(id, isPreview) {
      firebase.functions.httpsCallable('getTweetEmbed')({ id })
        .then((result) => {
          if(isPreview){
            this.previewHtml = result.data.tweet.html
          } else {
            this.html = result.data.tweet.html
          }
          window.twttr.widgets.load()
        }).catch(() => {
          this.errors.showTwitterError = true
        })
    },

    select(ref, model){
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },

    async publish() {
      let hasError = false

      this.resetMessages()
      if(!this.isValid()){
        return
      }

      const set = {
        tweetId: this.linkMatch[3],
        userId: this.$store.state.auth.user.uid,
        title: this.title.trim(),
        primaryTags: this.primaryTags,
        secondaryTags: this.secondaryTags,
        isBot: false,
      }

      try {
        await firebase.functions.httpsCallable('postThread')(set)
      } catch (error) {
        console.error(error)
        hasError = true
        this.errors.showServerError = true
        return
      }
      
      for(let t of this.secondaryTags){
        try {
          await firebase.firestore.collection("secondary-tags").doc().set({
            name: t.toLowerCase().trim(),
            createdAt: firebase.Timestamp.now(),
          })
        } catch (error) {
          console.error(error)
          hasError = true
          this.errors.showServerError = true
          return
        }
      }

      if(!hasError){
        firebase.analytics.logEvent('post_created', set)
        router.push({ path: '/' })
      }
    },

    resetMessages() {
      this.errors.showMissingLinkError = false
      this.errors.showMissingTitleError = false
      this.errors.showMissingPrimaryTagsError = false
      this.errors.showTwitterError = false
      this.errors.showServerError = false
      this.errors.showSuccess = false
    },

    isValid() {
      if(!this.isValidLink){
        this.errors.showMissingLinkError = true
        return false
      }

      if(this.title === ''){
        this.errors.showMissingTitleError = true
        return false
      }

      if(this.primaryTags.length === 0){
        this.errors.showMissingPrimaryTagsError = true
        return false
      }

      return true
    }
  },

}
</script>

<style scoped>
.header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
}
.page-container{
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
.new-thread-post-container{
  background-color: var(--global-header-color);
  max-width: 550px;
  padding: 2.5em;
  border-radius: 8px;
  margin-bottom: 20%;
  margin: 1em 0 2m 0;
}
.thread-preview-container{
  background-color: var(--secondary-light-color);
  padding: 30px;
  width: inherit;
  border-radius: 8px;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
  .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}
</style>
